import React, { useEffect, useState } from 'react';
import styles from "./TagGroups.module.css";
import edit from "../../../../../../assets/Edit.svg";
import deleteBtn from "../../../../../../assets/Delete.svg"
import TagGroupModel from './TagGroupModel';
import portlessProxy from 'bareproxy';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getGraphData } from '../../../../../../redux/slices/viewDataSlice';
import tableInitWorker from 'Utils/restructure.worker';
import WorkerBuilder from 'Utils/builder.worker';
import { deleteTagGroup, fetchTagGroups } from '../../../../../../redux/slices/tagGroupSlice';
import { useToast } from "@chakra-ui/react";
import proxy from 'proxy';

const io = require('socket.io-client');
const tableInitializer = new WorkerBuilder(tableInitWorker);

const TagGroups = () => {
    const [isModel, setIsModel] = useState(false);
    const [modelTitle, setModelTitle] = useState("");
    const [liveChannels, setLiveChannels] = useState([]);
    const [socket, setSocket] = useState(io(portlessProxy, { // Initializes socket connection
        cors: {
            origin: '*',
            allowedHeaders: ['*'],
            allowedMethods: ['GET', 'POST'],
            insecure: true,
        },
    }));
    const [selectedGroupId, setSelectedGroupId] = useState("");
    const [selectedGroupName, setSelectedGroupName] = useState("");
    const [savedChannels, setSavedChannels] = useState([]);
    const [searchParams] = useSearchParams();
    const uniqueProjectId = searchParams.get('project');
    const dispatch = useDispatch();
    const toast = useToast();
    const graphData = useSelector((state) => state.viewData.graphData);
    const tagGroupsArr = useSelector((state) => state.tagGroup.tagGroupsArr);

    const projectID = searchParams.get('project');

    useEffect(() => {
        dispatch(fetchTagGroups(uniqueProjectId));
    }, [uniqueProjectId])

    useEffect(() => {
        if (graphData.length > 0) {
            // Parsing data from from get request in the parent component
            const copiedDataset = [...graphData];
            const fetchData = async () => {
                try {
                    if (graphData.length > 0) {
                        // Live Data Chart
                        const currentTime = new Date();
                        currentTime.setTime(currentTime.getTime() - 1 * 60 * 60 * 1000); // Subtracting 1 hour
                        const liveDataFiltered = copiedDataset.filter(
                            (dataset) => new Date(dataset.time) >= currentTime,
                        );
                        // Restructure Data for Table
                        const tableDataArrayGen = async () => {
                            const dataPromise = new Promise((resolve) => {
                                tableInitializer.onmessage = (e) => {
                                    resolve(e.data);
                                };
                            });
                            tableInitializer.postMessage({ data: liveDataFiltered });
                            return await dataPromise;
                        };
                        const tableDataArray = await tableDataArrayGen();
                        let gotHeaders = [];
                        if (tableDataArray.data) {
                            gotHeaders = tableDataArray.headers;
                            console.log("gotHeaders:", gotHeaders);
                            // setLiveChannels(gotHeaders);

                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        }
    }, [graphData]);




      useEffect(() => {
        const fetchChannels = async () => {
            try {
                const token = localStorage.getItem("token");
    
                const response = await fetch(
                    `${proxy}/api/projectChannelList?projectId=${projectID}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
    
                const result = await response.json();
    
                if (Array.isArray(result.data)) {
                    setLiveChannels(result.data);
                } else {
                    setLiveChannels([]);
                }
            } catch (err) {
                console.log(err);
                setLiveChannels([]);
            }
        };
    
        if (projectID) {
            fetchChannels();
        }
    }, [projectID]);

    useEffect(() => {
        socket.on('connect', () => {
            console.log("Socket Connected Sucessfully")
        });
        socket.emit('joinRoom', `${uniqueProjectId}`);
        socket.on('message', (data) => {
            const newData = JSON.parse(data);
            let channels = [];
            if (Array.isArray(newData)) {
                newData.forEach((data) => {
                    channels.push(data.Header)
                });
                setLiveChannels(channels);
            }
        });
    }, [])

    const handleEditModel = (e, id, groupName, channels) => {
        e.preventDefault();
        setIsModel(true);
        setModelTitle("Edit");
        setSelectedGroupId(id);
        setSelectedGroupName(groupName)
        setSavedChannels(channels)
    }

    const handleAddModel = (e) => {
        e.preventDefault();
        setIsModel(true);
        setModelTitle("Add");
        setSelectedGroupId();
        setSelectedGroupName();
        setSavedChannels([]);
    }

    const handleDeleteGroup = (e, id) => {
        e.preventDefault();
        dispatch(deleteTagGroup(id)).then((result) => {
            if (result.payload.status === 200) {
                toast({
                    title: result.payload.responseBody.message || "Deleted Successfully",
                    status: "success",
                    position: "top-right",
                    duration: 5000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: result.payload.responseBody.message || "!Something went wrong",
                    status: "error",
                    position: "top-right",
                    duration: 5000,
                    isClosable: true,
                });
            }
        });
    }

    return (
        <>
            <div className={styles.page}>
                <div className={styles.container}>
                    <div className={styles.titleOptions}>
                        <div className={styles.titleText}>Groups</div>
                        <div className={styles.titleText}>Channels</div>
                    </div>
                    {tagGroupsArr?.map((group, index) => (
                        <div className={styles.group} key={index}>
                            <div className={styles.groupName}>{group.groupName}</div>
                            <div className={styles.selectChannels}>
                                <select className={styles.selectTag}>
                                    {group.channels.map((channel, idx) => (
                                        <option value={channel.trim()} key={idx}>
                                            {channel}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className={styles.btnWrapper}>
                                <button className={styles.btn} onClick={(e) => handleEditModel(e, group._id, group.groupName, group.channels)}>
                                    <img src={edit} alt="Edit" />
                                </button>
                                <button className={styles.btn}>
                                    <img src={deleteBtn} alt="Delete" onClick={(e) => handleDeleteGroup(e, group._id)} />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
                <button className={styles.addBtn} onClick={(e) => handleAddModel(e)}>
                    Add Group
                </button>
            </div>
            {isModel && (
                <TagGroupModel
                    liveChannels={liveChannels}
                    modelTitle={modelTitle}
                    setIsModel={setIsModel}
                    uniqueProjectId={uniqueProjectId}
                    selectedGroupId={selectedGroupId}
                    selectedGroupName={selectedGroupName}
                    savedChannels={savedChannels}
                />
            )}
        </>

    );
};

export default TagGroups;